import { useCallback } from 'react';

import { useAppDispatch } from './useAppDispatch';
import { clearPersistedCache } from '../providers/QueryProvider';
import { setAuthUser } from '../store/auth/auth.actions';
import storage from '../utils/storage';
import { reset } from '../libs/chatwoot';

/**
 * sessionStorage flag: set it to `String(performance.timeOrigin)` before logout() and the sign-in
 * page of the reloaded document confirms the password change.
 */
export const PASSWORD_CHANGED_NOTICE = 'xver:notice:password-changed';

export default function useLogout(): () => void {
    const dispatch = useAppDispatch();

    const logout = useCallback(async () => {
        // Token first: anything the cache clear re-triggers must not be able to
        // refetch as the outgoing account.
        storage.remove('_zugang');
        try {
            reset();
        } catch (e) {
            console.error(e);
        }
        dispatch(setAuthUser(undefined));
        await clearPersistedCache();
        // Full reload rather than navigate(): the QueryClient is a module-level
        // singleton, so only replacing the document guarantees it is empty.
        window.location.assign('/');
    }, [dispatch]);

    return logout;
}
